module.exports = "/_next/static/images/icon_instagram3-0a5a29943f584f8b84bbff78154e7831.svg";